import { wasteManagementEnumsWasteInvolvedOptionEnum } from '@/gen/types/WasteManagementEnumsWasteInvolvedOption';

import { whenPathIncludes } from './conditions';
import type { IncidentFieldRule } from './types';

export const wasteManagementFieldRules: IncidentFieldRule[] = [
    {
        key: 'subCategory',
        label: 'What happened?',
        description: 'Select the type of waste management incident.',
        order: 90,
    },
    {
        key: 'wasteInvolved',
        label: 'What type of waste was involved?',
        description: 'Select all waste types involved, e.g. hazardous, electronic, general.',
        order: 100,
    },
    {
        key: 'wasteInvolvedExplanation',
        label: 'Waste involved explanation',
        kind: 'textarea',
        order: 110,
        visibleWhen: whenPathIncludes('wasteInvolved', wasteManagementEnumsWasteInvolvedOptionEnum.Other),
        requiredWhen: whenPathIncludes('wasteInvolved', wasteManagementEnumsWasteInvolvedOptionEnum.Other),
    },
];
